import { useState } from "react";
import { FaRegCopy, FaCheck } from "react-icons/fa";

export const CopyValue = ({ value, isMono = true, label = "Copiar" }) => {

    const [useIsCopied, setIsCopied] = useState(false);

    const onCopy = async () => {

        if (!value) return;

        try {
            await navigator.clipboard.writeText(String(value));
        } catch {
            const AREA = document.createElement("textarea");
            AREA.value = String(value);
            document.body.appendChild(AREA);
            AREA.select();
            document.execCommand("copy");
            document.body.removeChild(AREA);
        }

        setIsCopied(true);
        setTimeout(() => setIsCopied(false), 1600);
    };

    return (
        <span className="LStudio__app_copy" data-mono={isMono}>

            <span className="LStudio__app_copy_value" title={value == null ? "" : String(value)}>{value}</span>

            <button type="button" className="LStudio__app_copy_button"
                onClick={onCopy} aria-label={label} title={useIsCopied ? "Copiado" : label}>
                {useIsCopied ? <FaCheck /> : <FaRegCopy />}
            </button>

        </span>
    );
};
